export default "__VITE_ASSET__DdtNFV3q__"